<div>
    <label>{{ label }}</label>
    <div class="bciti-select bciti-select-input" (click)="toggleDropdown()" #dropreference>
      <ul>
        <li>
          <span *ngIf="selected">{{ selected.identity.label[currentLang] }}</span>
          <span class="placeholder" *ngIf="!selected"> {{ placeholder }}</span>
          <span [ngClass]="dropdown.showing ? 'icon-caret-up' : 'icon-caret-down'" class="icon"></span>
        </li>
      </ul>
      <app-config-cards-select-dropdown [reference]="dropreference" #dropdown>
        <div class="bciti-select bciti-select-dropdown no-margin">
          <ul>
            <ng-container *ngFor="let option of options">
              <li (click)="select(option)" *ngIf="option !== selected">
                {{ option.identity.label[currentLang] }}
              </li>
            </ng-container>
          </ul>
        </div>
      </app-config-cards-select-dropdown>
    </div>
  </div>